"use client";

import { ReactNode } from "react";
import Link from "next/link";

interface AuthLayoutProps {
  title: string;
  subtitle?: string;
  footer?: ReactNode;
  children: ReactNode;
}

export function AuthLayout({
  title,
  subtitle,
  footer,
  children,
}: AuthLayoutProps) {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center legal-pad-bg p-4 relative">
      {/* Red margin lines */}
      <div className="absolute top-0 bottom-0 left-[var(--pad-margin-line1)] w-[1px] bg-[var(--color-pad-margin-red)]" />
      <div className="absolute top-0 bottom-0 left-[var(--pad-margin-line2)] w-[1px] bg-[var(--color-pad-margin-red)]" />

      <div className="w-full max-w-md relative z-10">
        {/* Logo */}
        <div className="text-center mb-8">
          <Link href="/" className="inline-flex items-center gap-3 group">
            <div className="w-10 h-10 bg-yellow-300 rounded-lg border-2 border-yellow-400/50 shadow-md flex items-center justify-center relative overflow-hidden group-hover:scale-105 transition-transform">
              <div className="absolute top-0 left-[10px] w-[1px] h-full bg-red-400/60"></div>
              <span className="text-lg font-bold text-yellow-900 ml-1">L</span>
            </div>
            <span className="text-2xl font-bold text-neutral-800 tracking-tight">
              Legal Pad.
            </span>
          </Link>
        </div>

        {/* Auth Card */}
        <div className="bg-[var(--color-surface)]/95 backdrop-blur-sm rounded-2xl shadow-xl p-8 animate-stick-in border border-[var(--color-border)]">
          <div className="mb-6">
            <h2 className="text-2xl font-bold text-[var(--color-text-primary)]">{title}</h2>
            {subtitle && (
              <p className="mt-2 text-sm text-[var(--color-text-secondary)]">{subtitle}</p>
            )}
          </div>

          {children}
        </div>

        {/* Footer */}
        {footer && <div className="mt-6 text-center">{footer}</div>}
      </div>
    </div>
  );
}
